module.exports = __webpack_public_path__ + "static/media/faramoozSign.bca08912.png";